(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scorpio-collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-scorpio-step]');
    if (!button) return;
    const row = document.getElementById(button.getAttribute('aria-controls'));
    if (!row) return;
    row.scrollBy({ left: row.clientWidth * Number(button.dataset.scorpioStep), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yalorde-jaguar-vertical"] && !Shopify.designMode) return;
  try {
    
  const updateJaguarControls = (list) => {
    const section = list.closest('.jaguar-edit');
    if (!section) return;
    section.querySelectorAll('[data-jaguar-step]').forEach((button) => {
      const direction = Number(button.dataset.jaguarStep);
      button.disabled = direction < 0
        ? list.scrollTop <= 1
        : list.scrollTop >= list.scrollHeight - list.clientHeight - 1;
    });
  };
  const setupJaguarLists = () => {
    document.querySelectorAll('.jaguar-edit__list').forEach((list) => {
      if (list.dataset.scrollReady) return;
      list.dataset.scrollReady = 'true';
      list.addEventListener('scroll', () => updateJaguarControls(list), { passive: true });
      list.addEventListener('wheel', (event) => {
        if (event.ctrlKey || event.deltaY === 0 || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
        const delta = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? list.clientHeight : 1);
        const canScroll = delta > 0
          ? list.scrollTop < list.scrollHeight - list.clientHeight - 1
          : list.scrollTop > 1;
        if (!canScroll) return;
        event.preventDefault();
        list.scrollTop += delta;
      }, { passive: false });
      new ResizeObserver(() => updateJaguarControls(list)).observe(list);
      list.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => updateJaguarControls(list), { once: true });
      });
      updateJaguarControls(list);
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-jaguar-step]');
    if (!button || button.disabled) return;
    const list = document.getElementById(button.getAttribute('aria-controls'));
    if (!list) return;
    const card = list.querySelector('.jaguar-edit__product');
    const step = card ? card.getBoundingClientRect().height + parseFloat(getComputedStyle(card).marginBottom || 0) : list.clientHeight * .8;
    list.scrollBy({ top: step * Number(button.dataset.jaguarStep), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  setupJaguarLists();
  document.addEventListener('shopify:section:load', setupJaguarLists);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yalorde-portfolio-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('portfolio-carousel')) {
    customElements.define('portfolio-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.yl-portfolio__track');
        this.slides = [...this.querySelectorAll('.yl-portfolio__slide')];
        this.dots = [...this.querySelectorAll('.yl-portfolio__dot')];
        this.index = 0;
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slide))));
        this.track.addEventListener('scroll', () => this.updateFromScroll(), { passive: true });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      goTo(index) {
        const target = this.slides[index];
        if (!target) return;
        this.index = index;
        this.track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        this.updateDots();
      }

      updateFromScroll() {
        if (!this.track.clientWidth) return;
        const next = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (next !== this.index) {
          this.index = next;
          this.updateDots();
        }
      }

      updateDots() {
        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      start() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const speed = Number(this.dataset.speed) || 5000;
        this.timer = setInterval(() => this.goTo((this.index + 1) % this.slides.length), speed);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
